import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const useUpdatePhone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePhone,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['customer', 'account'] }),
  });
};

const updatePhone = async (props: UpdatePhoneParams) => {
  await api.put<void>(apiConfig.routes.auth.updatePhone, props);
};

type UpdatePhoneParams = {
  phone: string;
};
